import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-navy-soft py-20" aria-labelledby="faq-title" data-id="element-74" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-75" data-mp="1cfjd03drykpe">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-white md:text-4xl" data-id="element-76" data-mp="1ccndiama3nyu">
          Frequently Asked Questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-77" data-mp="254gsxzuik5ez">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-lg border bg-steel transition-colors duration-150 ease-out ${isOpen ? 'border-gold' : 'border-gold/30'}`} data-id="element-78" data-mp="1v5hkoidnubsi" data-mpi={index}>
                <h3 className="font-sans" data-id="element-79" data-mp="jp1d1b8ckzg7">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-white transition-colors duration-150 ease-out hover:bg-navy-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-mineral/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-80" data-mp="js5jygd769ak">
                    <span data-id="element-81" data-mp="11vxpbmhzluu6">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-mineral transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-82" data-mp="16np83auwiw9r" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-83" data-mp="iyd02ebb8u91">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-84" data-mp="j0hbdhbjgvjc">
                      <p className="border-t border-white/10 px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-85" data-mp="2ku3owsyeyos6">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}